import { render } from "./XsollaLogo.vue?vue&type=template&id=6e83d7c5&ts=true"
import script from "./XsollaLogo.vue?vue&type=script&lang=ts"
export * from "./XsollaLogo.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/clickfun/frontend/clickfun_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__